const gameEN = {
    changeDay: {
        header: "New Day",
        link: "You hear the alarm sound..."
    },

    endDidntPayRent: "<1>BAD ENDING. Can't pay rent</1>" +
        "<2/>" +
        "The landlord yelled at you for a long time, and then just took and evicted.\n" +
        "You and <3>wife</3> first moved in with her parents, and then everything went awry there too.\n" +
        "As a result, <3>wife</3> divorced you, and after long wanderings from motel to motel, you ended up on the street.\n\n" +
        "<4>Start over</4>",

    endBadRelationsWithWife: "<1>BAD ENDING. Bad relationship with {{wife}}</1>" +
        "<2/>" +
        "You woke up in the morning and found <3>wife</3> packing her things into suitcases." +
        "<4>{{wife}}, what are you doing?</4>" +
        "<5>I pack my things and move to my parents.</5>" +
        "<4>What? What are you talking about???</4>" +
        "<5>Literally, {{player}}, I'm tired of all this.</5>" +
        "<4>Wait, let's discuss the whole situation and...</4>" +
        "<5>No, {{player}}, we have nothing more to discuss.</5>\n\n" +
        "...\n\n" +
        "<6>Start over</6>",

    playAsNow: "<1>You are playing as {{name}} now.</1>" +
        "<2>Continue</2>",

    courierJob: {
        e01: "<1>Work...</1>" +
            "<2/>" +
            "You spend your time on the road delivering orders to customers. Nothing interesting happens. In principle, as always in this work.",
        e02: "The workday is over.\n\n" +
            "<1>Come back home</1>",
        e03: "<1>Return to the warehouse</1>"
    },

    courierJobEventMoto: "<1>Work...</1>" +
        "You were peacefully driving along the path of one of the orders when a motorcyclist began to overtake you. " +
        "At first you did not pay attention to him, but then you noticed that a woman in a skirt was sitting behind him. The wind kept blowing her skirt off her gorgeous ass." +
        "<2/>" +
        "There was a very open thongs under the skirt, under which you noticed... a butt plug?\n" +
        "Having stepped on the gas, you watched this picture for some time, but then the motorcycle finally moved away. Then you realized that you got a hard on.\n\n" +
        "<3>Go further</3>",

    courierJobEventCar: "<1>Work...</1>" +
        "You were standing in the town center in a traffic jam at one of the traffic lights. After dreaming, you stopped watching yourself, and when you woke up, you realized that your gaze was drilling the driver woman who was sitting in the next car. " +
        "She looked at you too. When you realized this, you immediately looked away. " +
        "But something in this woman apparently hooked you, so after a while you turned your eyes back to her. She was still looking at you and smiling.\n" +
        "You looked away again, and then looked back at the woman. Then she suddenly showed you a sign with her hand, which meant \"one moment\", and then she ..." +
        "<2/>" +
        "And then she just took it and showed you her magnificent breasts. From what you saw, you almost drove into the car that was in front of you. " +
        "And when you looked back at the woman, she was already two cars ahead of you. Your dick was hard and it commanded you to catch up with that woman.\n" +
        "But in a traffic jam it didn't work out, so you decided to go further.\n\n" +
        "<3>Go further</3>",

    courierJobEventDelivery: "<1>Work...</1>" +
        "You went up with the goods to one of the apartments, not expecting anything unusual, then rang the bell. " +
        "A few moments later, the door was opened by a young woman of about 20. She was wearing only white underwear. " +
        "You immediately looked away, gave her the goods and asked for payment, still not looking at her." +
        "<2>Please come in, I don't want everyone to see me like this.</2>She said.\n" +
        "You agreed and went to the apartment. But instead of paying, a slightly different surprise was waiting for you there..." +
        "<3/>" +
        "The woman slowly began to remove her bra." +
        "<2>Is there any other way to pay it off?</2> You froze as if rooted to the spot and regained consciousness only when she began to approach you." +
        "<4>No, madam... um... miss... I'd love to... But I'm not legally allowed to...</4> The woman did not expect such an answer.\n" +
        "She was confused for a second, then covered her chest with her hands and went for the money.\n" +
        "When she returned, she was already wearing a bathrobe." +
        "<2>Here, keep the change.\n</2>" +
        "<4>Thank you miss...</4>You said and tried to look for the door behind you with your hand. A minute later you was already out of the floor. In the elevator, you grabbed your dick - it was hard.\n\n" +
        "<5>Go further</5>",

    courierJobEventDelivery1: "<1>Work...</1>" +
        "You came to the nearest suburb with another package and rang on the bell in one of the houses. " +
        "The door was opened for you by a 25-year-old woman with dark hair and... wearing only shorts and a tank top. She invited you to enter, but you only entered the corridor and stopped there. " +
        "You gave her the package and out of control started staring at her underwear. She didn't want to leave either. " +
        "Then, after all, she left the package you delivered on the floor and went for the money. " +
        "The panties turned out to be thongs and now two perfect halves of her ass were looking at you. Your gaze was riveted only to them." +
        "<2/>" +
        "The woman disappeared from your field of vision, and appeared in it only after a few minutes. " +
        "Aand... She was without panties, but at the same time she handed you money for delivery. Of course, you didn't immediately notice the money, as you were staring at her perfectly shaved pussy. " +
        "Only when she came up to you and said:" +
        "<3>You can touch if you want.</3>" +
        "Immediately after that, you woke up, answered her in the negative, took the money and quickly went out the door. The drawers had a huge hard-on.\n" +
        "It looks like there are some positives in your work...\n\n" +
        "<4>Go further</4>",

    courierJobEventDelivery2: "<1>Work...</1>" +
        "You went up to another client who lived on the outskirts of the town.\n" +
        "When you came to the door, you wanted to ring the bell, but saw that the door was ajar. " +
        "This was often done by customers, especially with a non-cash method of paying. But it was imperative to let them know about you so that the person knew that the courier had arrived.\n" +
        "So when you went inside and did not find a single person in the corridor, you shouted that the courier had arrived. " +
        "But there was no answer. After standing like this for about two minutes, you began to distinguish some sounds from the nearest room. " +
        "Then you decided to go there and call the owner.\n Approaching, you saw the following picture: the woman was lying on the bed and masturbating." +
        "<2/>" +
        "After looking a little at this charm and dreaming a little, you quietly closed the door, and then knocked on it and said loudly \"Courier\". " +
        "There were some sudden movements and the woman shouted back, \"Okay, thanks, don't just come here!\". " +
        "You smiled slyly, but answered \"Okay, all the best!\", after which you left the apartment. You found out great hard on in your pants.\n\n" +
        "<3>Go further</3>",

    courierJobEventDelivery3: "<1>Work...</1>" +
        "You were delivering another pack to an apartment in one of the central districts of the town. The pack was heavy enough that you could barely drag it to the third floor.\n" +
        "The door was opened by a thin man in his forties." +
        "<2>Good afternoon.</2> He said and stepped aside, letting you in.\n" +
        "You barely made it through the door with that big box. And when entered, you immediately put it on the floor." +
        "<2>Can you take it to the back room, please? It's very heavy for me.</2>" +
        "<3>Okay, just take a breath...</3>You said, mentally sending him to hell.\n" +
        "Suddenly, the phone rang in the next room. The man jumped up and ran to pick up the phone, shouting to you:" +
        "<2>I need to respond urgently for work. Please take the box to the furthest room along the corridor.</2>" +
        "You sent him away again in your head. " +
        "But having caught your breath a little, you took the box and dragged it along the corridor. Doors were open to the right and left, where you didn't look much, trying to focus on the box.\n" +
        "In the end, you almost threw it on the floor next to the bed. \"That's it, fuck him, why the fuck I've got to carry anything for him.\" " +
        "With these thoughts, you went back. But along the way, your eyes fell on one of the rooms that you had not paid attention to before. " +
        "It turned out to be a bathroom, a woman was standing in it and... playing with a vibrator..." +
        "<4/>" +
        "You stopped and started looking at this scene. With every minute you were more and more excited, and she was getting closer to orgasm...\n" +
        "You came to your senses only when the woman had finished and was shaking all over. Then you pulled yourself together and continued to move towards the exit.\n\n" +
        "<5>Go further</5>",

    courierJobEventStairs: "<1>Work...</1>" +
        "You were delivering another package to one of the apartments in one of the peripheral quarters of the town. " +
        "Approaching the entrance of the house at the address, you almost ran face to face with a woman who was also walking into the entrance." +
        "<2>Excuse me, please go through.</2> You said, a little taken aback." +
        "<3>Thank you.</3> She replied as if nothing had happened." +
        "The woman had dark hair tied in a braid, a T-shirt with a black bra sticking out from under it, and short shorts.\n" +
        "When you followed her up the stairs, of course, you couldn't look anywhere but her ass." +
        "<4/>" +
        "As a result, after several spans, your paths crossed and you successfully delivered the package.\n\n" +
        "<5>Go further</5>",

    courierJobEventStore: "<1>Work...</1>" +
        "During one of the trips, you realized that you were hungry and decided to stop by one of the supermarkets that are located in the northern part of the town.\n" +
        "You went inside and were walking towards the prepared food section when your eyes fell on a woman in a big black hat and short denim shorts. " +
        "She stood doggystyle towards you, bending over for some sweets on the first shelf. " +
        "You couldn't stand such a great view, so you involuntarily stopped and even took a few steps back to get a better look at the woman's ass. And the ass was top notch." +
        "<2/>" +
        "You admired it, forgetting about all the norms of decency. So when the woman straightened up and looked at you, you continued to look at her ass.\n" +
        "Soon you woke up and noticed that the woman was staring at you and smiling in response. You blushed all over, but she didn't care. " +
        "She realized that you were enjoying the sight of her ass, but did not tell you anything. " +
        "Instead, she went in your direction and... she also exposed her breasts, showing it only to you. You had a huge boner sticking out of your pants.\n" +
        "Then the woman smiled at you again and went to another section. You looked at your boner and adjusted it. After a while you were already at the cashier.\n\n" +
        "<3>Go further</3>",

    courierGoHome: "<1>Coming home from work</1>" +
        "<2/>" +
        "Tired and dissatisfied, you return home from work.\n\n" +
        "<3>Arrived</3>",

    courierJobOffice: "<1>Office</1>" +
        "<2/>" +
        "The usual small office space with a large warehouse.\n" +
        "Now you don't know anyone here, and there's nothing for you to do here.\n\n" +
        "<3>Come back</3>",

    courierJobOfficeWorker: "<1>Hi, how are you? Everything's OK?</1>" +
        "<2>Yes, it's all right, thanks.</2></4></4>" +
        "<3>Move away</3>",

    courierJobOfficeWorkerAsWife: "<1>wife</1> and <2>worker</2> sat and chatted a little about all sorts of trifles.\n\n" +
        "<3>Back</3>",

    courierJobOfficeColleaguesAsWife: "<1>Office</1>" +
        "<2/>" +
        "<3>wife</3> talked a little with colleagues from the office.\n\n" +
        "<4>Back</4>",

    courierJobOfficeWifeDoNotDisturb: "<1>Please don't disturb me, {{player}}, I'm working...</1>" +
        "<2>Okay, sorry babe.</2><4/><4/>" +
        "<3>Back</3>",

    courierJobOfficeWorkerStart: "<1>Some guy in the office</1>" +
        "You entered the office and took a couple of unconvincing steps towards its employees. " +
        "Realizing that no one even notices you, you approached the tables with more confident steps. For some reason, there were almost no workers, except for one, to whom you approached." +
        "<2>Hmmm... hello...</2>The dude didn't raise his head at you and continued to look at the computer as if nothing had happened.\n" +
        "Then you spoke louder:" +
        "<2>Hello!</2>The dude winced and looked at you. It was a young man in his 30s with a large pointed nose and curly brown hair." +
        "<3/>" +
        "<4>Yes, I'm sorry, do you need something?</4>" +
        "<2>Yes, hello again... My name is {{player}}, I work as a courier for you downstairs.</2>" +
        "<4>Hi {{player}}, I'm {{worker}}, I'm doing HR here. Is there anything I can help you with?</4>" +
        "\"That's so good luck, the first time and right in the bull's-eye!\" - You thought." +
        "<2>I think you are exactly what I was looking for. You see, this is the situation...</2>" +
        "<4>Forgive me for interrupting. I don't know how you communicate down there, but we're all like friends here. So please don't use formal language here, is it okay with you?</4>" +
        "<2>Yes, of course... Um, there you go. Such situation. My wife is now looking for a job and she said that she saw a vacancy in our office on the Internet ...</2>" +
        "<4>Yes, we have a couple of vacancies. Who is your wife?</4> You hesitated again." +
        "<2>Her name is {{wife}}.</2>" +
        "<4>Well no! What is your wife's occupation? And what job is she applying for?</4>" +
        "<2>She recently graduated from college with a degree in design, but she wants to join us for the vacancy of an office manager.</2>" +
        "<4>Yes... a bit of an odd choice. Why office manager? There is a small salary.</4>" +
        "<2>Good position and money to start.</2><5>worker</5> looked back at the computer." +
        "<4>Well, if she doesn't change her mind, then give her this number, let her call and we will arrange a meeting.</4>" +
        "He pulled out a business card from his bag and handed it to you." +
        "<2>Okay, thanks...</2> You took his card and were about to leave, as <5>worker</5> said:" +
        "<4>And how are you doing down there? Things are good?</4>" +
        "<2>Yes, it's all right, thanks.</2>" +
        "<4>Okay, glad to hear. Well, if there are any problems or questions, come and chat.</4>" +
        "<2>Well thank you.</2> You turned and walked towards the stairs to the warehouse.\n\n" +
        "<6>Get down</6>",

    playComputer: "<1>Computer games</1>" +
        "<2/>" +
        "You have fun playing computer games.\n\n" +
        "<3>Finish</3>",

    watchPorn: "<1>Porn</1>" +
        "<2/>" +
        "You relax by watching porn. Something starts to move in your pants.\n\n" +
        "<3>Finish</3>",

    dontGoOutsideAtNight: "<1>It's too late</1>" +
        "<2/>" +
        "You don't want to go outside because it's very late and you want to sleep.\n\n" +
        "<3>Go back</3>",

    cantGoToBathroom: "<1>Won't go there</1>" +
        "<2/>" +
        "You don't want to go into the bathroom because <3>wife</3> is being washed there." +
        "<4>{{wife}} relationships > {{relations}}.</4><5/><5/>" +
        "<6>Go back</6>",

    dontGoToWork: "<1>Absenteeism from work</1>" +
        "<2/>" +
        "You went out into the street, realizing that you missed today's work shift.\n\n" +
        "<3>So, to hell with it!</3>",

    pillsInstruction: {
        header: "<1>Manual for pills</1>",
        body: "<1>Description</1>" +
            "Капсулы твердые желатиновые №1. Корпус белого цвета, крышечка желтого цвета. " +
            "The contents of the capsules are a mixture containing granules and powder from white to white with a greenish-yellowish or creamy tint." +
            "<1>Indications for use</1>" +
            "The drug is intended for use by persons strictly older than 21 years. " +
            "Therapy of obsessive-compulsive disorders, namely, obsessive fears that are not currently connected with the content of consciousness and are perceived by patients as emotionally unpleasant." +
            "<1>Contraindications</1>" +
            "Hypersensitivity to umifenovir or any component of the drug; age up to 21 years. " +
            "First trimester of pregnancy. breastfeeding period. Sinoatrial blockade. Unstable or acute heart failure. " +
            "The presence of an artificial pacemaker operating in the mode of constant stimulation. Unstable angina.\n" +
            "The effect of the application is permanent. To block any side effects, you must contact the manufacturer and clarify the availability of blocking agents.\n" +
            "Carefully:\n" +
            "Second and third trimesters of pregnancy." +
            "<1>Dosage and administration</1>" +
            "Dissolve the drug in any liquid in a volume of 200 ml, take it before eating." +
            "<1>Side effects</1>" +
            "The use of the drug was studied in studies involving almost 45,000 patients. " +
            "The most common side effects of ivabradine, changes in light perception (phosphenes) and bradycardia, were dose-dependent and were associated with the mechanism of action of the drug.\n" +
            "The frequency of adverse reactions that were noted in clinical studies is given as the following gradation: " +
            "very often (>1/10); often (>1/100, <1/10); infrequently (> 1/1000, <1/100); rarely (>1/10,000, <1/1000); very rarely (<1/10,000); unspecified frequency (frequency cannot be calculated from the available data)." +
            "<2>Changes in the behavior of the subject of the use of the drug are possible, as well as unexpected areas of life may be affected.</2>" +
            "<1>Manufacturer</1>" +
            "<3>ChainPharmOPS Corp</3>, 225 S 3rd St, Santa Marta, NM 88435\n" +
            "Phone: 555-2368 (phone, fax)\n" +
            "E-mail: help@chain.ph, site: www.chain.ph\n",
        link: "<1>Back</1>"
    },

    sleep: "<1>Night sleep</1>" +
        "<2/>" +
        "You worked hard during the day and passed out almost immediately.\n\n" +
        "<3>Sleep</3>",

    nap: "<1>Take a little nap</1>" +
        "<2/>" +
        "You lay down on the bed and closed your eyes. You did not notice how you dozed off and woke up only an hour later.\n\n" +
        "<3>Get up</3>"
};

export default gameEN;